<mat-card style="min-height: 500px">
    <mat-card-content>
        <div class="max-width">
            <div class="table-container">
                <div class="d-flex justify-content-center">
                    <mat-spinner *ngIf="loading"></mat-spinner>
                </div>
                <table mat-table *ngIf="data.length > 0 && !loading"
                       [dataSource]="data" multiTemplateDataRows
                       class="mat-elevation-z8 full-width-table">

                    <ng-container matColumnDef="student_name">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'STUDENT_NAME' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.student_name || '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="activity_name">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'ACTIVITY_NAME' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.activity_name || '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="is_paid">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'IS_PAID' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.is_paid ? 'Yes' : '-' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="payment_generated">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'PAYMENT_GENERATED' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.payment_generated ? 'Yes' : 'No' }}
                        </td>
                    </ng-container>
                    
                    <ng-container matColumnDef="total_fee">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'TOTAL_FEE' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.total_fee | currency:'IDR':'Rp'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="payment_date">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'PAYMENT_DATE' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{(element.payment_date | date:'medium') || '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="payment_notes">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'PAYMENT_NOTES' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.payment_notes || '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="payment_logs">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'PAYMENT_LOGS' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            <button class="action-btn action-btn-view" (click)="openPaymentLogsModal(element.registration_payment_id)">
                                <i class="fa fa-history me-1"></i> {{ 'Manual Payment History' | translate }}
                            </button>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center">{{ 'Action' | translate }}</th>
                        <td mat-cell *matCellDef="let element" class="example-element-weight">
                            <div>
                                <button class="action-btn action-btn-view" (click)="onShowPayment(element)">
                                    {{ 'Detail' | translate }}
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                    <tr mat-row *matRowDef="let element; let i = index; columns: columnsToDisplay;" class="example-element-row">
                    </tr>
                </table>
            </div>

        </div>
    </mat-card-content>
</mat-card>


<ng-template #paymentLogsModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title fw-bold">
            <i class="fa fa-history me-2"></i>
            {{ 'PAYMENT_LOGS' | translate }}
        </h5>
        <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <app-payment-manual-logs-table
            [registrationPaymentId]="selectedRegistrationPaymentId">
        </app-payment-manual-logs-table>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">
            {{ 'Close' | translate }}
        </button>
    </div>
</ng-template>

<ng-template #paymentModal>
    <div class="d-flex justify-content-center">
        <mat-spinner *ngIf="loadingVa"></mat-spinner>
    </div>
    <div *ngIf="!loadingVa" class="p-4">
        <div class="row mb-3">
            <div class="fw-bold">{{ 'STUDENT_NAME' | translate }}</div>
            <div>
                {{ registrationPaymentDetail.student_name || '-' }}
            </div>
        </div>
        <div class="row mb-3">
            <div class="fw-bold">{{ 'Activity Name' | translate }}</div>
            <div>
                {{ registrationPaymentDetail.activity_name || '-' }}
            </div>
        </div>
        <div class="row mb-3">
            <div class="fw-bold">{{ 'Payment Generated By Admin' | translate }}</div>
            <div>
                {{ registrationPaymentDetail.payment_generated ? 'Yes' : 'No' }}
            </div>
        </div>
        <div class="row mb-3">
            <div class="fw-bold">{{ 'Payment Method' | translate }}</div>
            <div>
                Virtual Account
            </div>
        </div>
        <div class="row mb-3">
            <div class="fw-bold">{{ 'Va Number' | translate }}</div>
            <div>
                {{ registrationPaymentDetail.va_number || '-' }}
            </div>
        </div>
        <div class="row mb-3">
            <div class="fw-bold">{{ 'Total Fee' | translate }}</div>
            <div>
                Rp {{ (registrationPaymentDetail.total_fee | number) || 0 }}
            </div>
        </div>
        <div class="row mb-3">
            <div class="fw-bold">{{ 'Payment Date' | translate }}</div>
            <div>
                {{ (registrationPaymentDetail.payment_date | date: 'dd/MM/yyyy') || '-' }}
            </div>
        </div>
        <div class="row mb-3">
            <div class="fw-bold">{{ 'Payment Notes' | translate }}</div>
            <div>
                {{ registrationPaymentDetail.payment_notes || '-' }}
            </div>
        </div>
        <div class="row mb-3">
            <div class="fw-bold">{{ 'PAYMENT_SLIP' | translate }}</div>
            <div>
                <a href="{{ registrationPaymentDetail.payment_slip.url }}" target="_blank">View Payment Slip</a>
            </div>
        </div>
    </div>
</ng-template>
